import React from 'react';
import PropTypes from 'prop-types';
import { Tag, Tooltip } from 'antd';
import { captureAnalyticsOncePerSession } from '../../actions/helpers/sessionAnalytics';
import './PartialFaxBadge.scss';

export const PARTIAL_FAX_LABEL = 'Partial';
export const PARTIAL_FAX_TOOLTIP = 'This fax may be missing pages: the sender\'s transmission was interrupted.';
export const PARTIAL_FAX_TOOLTIP_EVENT = 'partial_fax_tooltip_viewed';

// The tooltip is passive, so record adoption once per session rather than on every hover
// (app/javascript/src/AGENTS.md, Analytics).
export const onPartialFaxTooltipVisibleChange = (visible) => {
  if (visible) captureAnalyticsOncePerSession(PARTIAL_FAX_TOOLTIP_EVENT, {});
};

// ENG-3341: shown under the patient on an Inbox row when the inbound fax provider
// reported the transmission as interrupted (Phaxio partialsuccess, Telnyx
// partial_content, Sinch FAILURE with pages). Only received fax rows carry `partial`.
const PartialFaxBadge = ({ record }) => {
  if (record?.partial !== true) return null;

  return (
    <div className="partial-fax-badge">
      <Tooltip title={PARTIAL_FAX_TOOLTIP} onVisibleChange={onPartialFaxTooltipVisibleChange}>
        <Tag color="orange" className="partial-fax-badge__tag">{PARTIAL_FAX_LABEL}</Tag>
      </Tooltip>
    </div>
  );
};

PartialFaxBadge.propTypes = {
  record: PropTypes.shape({
    partial: PropTypes.bool,
  }),
};

PartialFaxBadge.defaultProps = {
  record: null,
};

export default PartialFaxBadge;
